import React from "react";
import "../../css/sharedStyles.css";
import "./SectionFeaturedComic.css";
import MoreButton from "../moreButton/MoreButton.js";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";
import { withRouter } from 'react-router-dom';

import {getComicListData} from "../includes/axios/getComicListData.js";
import {getCharacterListData} from "../includes/axios/getCharacterListData.js";
import {getMainCharacterData} from "../includes/axios/getMainCharacterData.js";
import LoaderAnimation from "../loaderAnimation/loaderAnimation.js"

var SectionFeaturedComic = class SectionFeaturedComic extends React.Component{
    constructor(props,newProps) {
        super(props);
        this.changeFeaturedComics = props.changeFeaturedComics;
        this.changeRelatedCharacters = props.changeRelatedCharacters;
        this.state = {
            featuredIsReady:false,
            popupData:[]
       }
       this.showComicArea = this.props.showComicArea;
       this.trimmedDescription;
    }


    componentDidMount(){
        //make sure the popup info window for the characters is hidden at each start
        this.props.showCharacterPopup(false);
    }//end componentDidMount() 


    componentDidUpdate(prevProps){
        //if the main characters name value has changed in Redux, update 
        //this.trimmedDescription = this.handleDescription();
        if(prevProps.characterInfo.character != this.props.characterInfo.character){
           
            var prevCharacter = prevProps.characterInfo.character;
            var prevID = prevProps.characterInfo.characterID;
            //console.log("prevCharacter: " + prevCharacter + " prevID: " + prevID);


            //this is a cheap hack. the sectionFeaturedComic module wont render anything unless 
            //the searched name is different than the current one. This is for infinite loop prevention. 
            //by setting the data to 'misspelled', it bypasses that check, then rerenders the current 
            //correct data   
            //sometimes, we're only in this part of the loop bc 'this.props.characterInfo.character' is 'misspelled'        
            var newCharacter = this.props.characterInfo.character;
            if(newCharacter === "misspelled"){
                var characterID = prevID;
                var changeFeaturedComics = this.props.changeFeaturedComics;
                getComicListData(characterID,changeFeaturedComics,12,this.showComicArea);
            }
            else{
                ///////get the comic list data from the API using the characterID in Redux
                var characterID = this.props.characterInfo.characterID
                var changeFeaturedComics = this.props.changeFeaturedComics;
                getComicListData(characterID,changeFeaturedComics,12,this.showComicArea);                
            }

        }//end if(prevProps)

        if(prevProps.characterInfo.featuredComicID != this.props.characterInfo.featuredComicID){
            if(newCharacter === "misspelled"){
                var comicID = prevProps.characterInfo.featuredComicID
                var changeRelatedCharacters = this.props.changeRelatedCharacters;  
                getCharacterListData(comicID,changeRelatedCharacters);
            }
            else{
                ///////get the character list data from the API using the featuredComicID in Redux
                var comicID = this.props.characterInfo.featuredComicID
                var changeRelatedCharacters = this.props.changeRelatedCharacters;  
                getCharacterListData(comicID,changeRelatedCharacters);
            }
        }//end if(prevProps)


    }
        

    handleDescriptionLength(){
        //limit the description to 300 characters in this display and add the '...' to it. CSS wanst working
        //IF we get the "I have no record ..." text, color it red using handledDescriptionColor()
        var description = this.props.characterInfo.comicsArray[0][1];
        var handledDescription = this.props.characterInfo.comicsArray[0][1].substring(0, 300);

        if(description.length >= 300){
            handledDescription += " . . .";
            var newText = this.handledDescriptionColor(handledDescription);
        } 
        if(description.length < 300){
            handledDescription = description; 
            var newText = this.handledDescriptionColor(handledDescription);
        }
        return newText;
    }



    handledDescriptionColor(description){
        if(description.indexOf("I have no record of a description") != -1){
            try{
                this.refs.description.style.color = "#da0000"; //red
            }
            catch(err){/*console.log("description doesnt exist it");*/} 
        }
        else{
            description = description;
            try{
                this.refs.description.style.color = "#2b98fb"; //jarvis blue
            }
            catch(err){/*console.log("description doesnt exist it");*/}  
        }
        return description;
    }


    //this has be be declared here bc of state. I dont feel like doing the whole thing in another file
    //this function is passed an image.src by clicking on a headshot. 
    //it finds the rest of its arrays data by comparing 'selectedImage' with the url in each array
    //that was first passed to this compnent to render the headshots in the first place.
    //it then stores the selected Array in state to be use in the popup
    getPopupInfo(selectedImage){
        this.props.showCharacterPopup(true);
        var characterArray; 
        this.props.characterInfo.relatedCharacters.map(function(item,index){
            if(selectedImage === item[2]){
                if(item[1] === "" || item[1] === null){
                    item[1] = "I was unable to find any data on " +  item[0];
                }
                this.setState({popupData:item})
            }
        },this)
    }

    popupCloseButton(characterName,changeCharacter,showComicArea){
        this.props.showCharacterPopup(false);
        getMainCharacterData(this.state.popupData[0],changeCharacter,showComicArea)
    }




  render(newProps) {
    //set in devLiveCheck.js. This is used to manage dir structure between local and live
    //the live site has '/jarvis/' after .com. 
    const routeBase = localStorage.getItem("routeBase"); 
    //this.trimmedDescription = this.handleDescription();
    //THIS IS THE TOP FEATURED AREA WHERE ITS ONE COMIC AND THEN CHARACTER ICONS  
        //we check to see if comicsAreaReadyToShow === true. since this area also uses the comics array
        //like the comic Appearances component, we render this when thats done. Shit this isnt gonna make sense later
    if(this.props.characterInfo.comicsAreaReadyToShow === true){

      //declare these two functions in this scope, so they can be called correctly in getMainCharacterData() below
      //when you click on a character icon
      var changeCharacter = this.props.changeCharacter;
      var showComicArea = this.props.showComicArea;
      
      if(this.props.characterInfo.showCharacterPopup === true){
        var popupStyle = "showPopup";
      }
      else if(this.props.characterInfo.showCharacterPopup === false){
        var popupStyle = "hidePopup";
      }

            return (
                <div className="featuredAppearance">

                    <div className="imageWrapper">
                        <img src={this.props.characterInfo.comicsArray[0][2]} alt={"featured comic"}/>
                    </div>
                    
                    <div className="detailArea">
                        <div className="featuredSection">

                            <img src = {this.props.characterInfo.comicsArray[0][2]} className="mobileOnlyImage" alt={"featured comic"}/>
                            
                            <div className="infoHolder">
                                <h1>{this.props.characterInfo.comicsArray[0][0]}</h1>
                                {/* <p>{this.props.characterInfo.comicsArray[0][1]}</p> */}
                                <p ref = "description">{this.handleDescriptionLength()}</p>

                                <Link to={routeBase + "/comicDetail"}>
                                    <MoreButton 
                                    functionToCall = {()=>{this.props.changeMainComic(this.props.characterInfo.comicsArray[0])}} 
                                   
                                     />
                                </Link> 

                            </div>
                        </div>



                        {/* /////////character icons ////////////*/}
                        <div className="characterSection">
                            <h1>Other Characters in this issue</h1>
                            <div style={{'width':'100%','float':'left'}}  ref="characterImages">
                         

                            {/* /////////// info popup area /////////// */}
                            <div className = {"infoPopup " + popupStyle}>
                                <div className = "infoPopupLeft">
                                    <img src={this.state.popupData[2]} />
                                </div>
                                <div className = "infoPopupRight">
                                    <div className="topRow">
                                        <div className="popupTitle">{this.state.popupData[0]}</div>
                                        <div className = "closeButton"
                                        onClick = {()=>{this.props.showCharacterPopup(false)}}
                                        >X
                                        </div>
                                    </div>
                                    <div className="description">{this.state.popupData[1]}</div>
                                    <Link to={routeBase + "/character"}>
                                        <MoreButton 
                                        functionToCall = {(id)=>{
                                            this.popupCloseButton(this.state.popupData[0],changeCharacter,showComicArea)}
                                        } 
                                    
                                        />
                                    </Link> 
                                </div>
                            </div>
                            {/* /////////// END info popup area /////////// */}



                            {
                             //LOOP through and render the characters in the featured issue  
                             //i add index to the key bc its stopping the unique ID error in react. Dont know why
                             
                             this.props.characterInfo.relatedCharacters.map(function(character,index){                               
                             //only show the other characters in issue. Not the current featured one
                             var selectedImage = character[2];
                             if(this.props.characterInfo.character != character[0]){
                                return <Link to = {routeBase + "/character"} key={index}>
                                <img src={ character[2] } className = "imageBorder"
                                        key={index} id={this.src} 
                                        ref={"characterImage"+index}
                                        onClick = {
                                            ()=>{
                                                this.getPopupInfo(selectedImage);
                                            }}
                                        alt = {"characterImage"+index}
                                    />
                                </Link>
                             }
                                     
                            },this)
                            }

                            </div>
                            
                            
                        </div>
                    </div> {/* detail area */}
                </div>// end featuredAppearance
            ); //end return
        }//end if(ready to show)
        else{
            return(
                <LoaderAnimation text = "Loading Featured Appearance" />
            )
        }


    }//end render()
  }

export default withRouter(SectionFeaturedComic);


// WEBPACK FOOTER //
// ./src/components/featuredComicArea/SectionFeaturedComic.js